// 都道府県特別交付税マッチング対応リクエストのメールテンプレート
{
  subject: "【事業立案＋AI】特別交付税（省令）マッチングの対応リクエスト",
  body: [
    "いつもご利用いただきありがとうございます。",
    "",
    "特別交付税（省令）マッチング機能の対応をリクエストいたします。",
    "",
    "【リクエストフォーム】",
    "",
    "---------------------------------------------------------------------------------",
    "自治体名： {{tenantName}}",
    "自治体コード： {{localGovernmentCode}}",
    "ご担当者名： {{userName}}",
    "メールアドレス： {{userEmail}}",
    "",
    "■ 備考（任意）：",
    "[こちらにご記入ください]",
    "",
    "---------------------------------------------------------------------------------",
    "",
    "対応可能な都道府県から順次対応を進めてまいります。",
    "ご協力のほど、よろしくお願い申し上げます。",
  ],
}
